import ErrorIcon from '@mui/icons-material/Error';
import { Tooltip } from '@mui/material';
import { ReactNode } from 'react';
import classNames from 'classnames/bind';

import styles from './Form.module.css';

const classCtx = classNames.bind(styles);

interface FormLabelProps {
	id?: string;
	text?: string;
	error?: boolean;
	errorText?: ReactNode;
	bold?: boolean;
	className?: string;
	required?: boolean;
}

/**
 * Custom Label component for Form Inputs. When input is in an error state the label will include an icon
 */
export default function FormLabel(props: FormLabelProps) {
	const containerClasses = classCtx({
		['input-label']: true,
		bold: Boolean(props.bold),
		error: Boolean(props.error),
		[props.className ?? '']: Boolean(props.className)
	});

	// when no text value (or error) is provided, it's assumed this component should not be rendered
	if (!props.text && !props.error) {
		return null;
	}

	return (
		<Tooltip title={props.errorText}>
			<div
				id={props.id}
				className={containerClasses}
			>
				<span>{props.text}</span>
				{props.required && !props.error && <span className={styles['required']}>*</span>}
				{props.error && <ErrorIcon fontSize='inherit' />}
			</div>
		</Tooltip>
	);
}
